import { takeEvery } from 'redux-saga'
import actions from 'actions'
import {
  eventGroupUpdateSaga,
  draftEventGroupSuccessSaga,
  draftEventGroupCancelSaga,
} from './event-group-details-sagas'

export function* watchDraftEventGroupSave() {
  yield* takeEvery(actions.DRAFT_EVENTGROUP_SAVE, eventGroupUpdateSaga)
}

export function* watchEntitiesEventGroupSuccess() {
  yield* takeEvery(actions.ENTITIES_EVENT_GROUP.SUCCESS, draftEventGroupSuccessSaga)
}

export function* watchDraftEventGroupCancel() {
  yield* takeEvery(actions.DRAFT_EVENTGROUP_CANCEL, draftEventGroupCancelSaga)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/event-group-details/event-group-details-watchers.js
 **/